import {
  OurProjectsBanner,
  OurProjectsClients,
  OurProjectsContact,
  OurProjectsLogo
} from '../../sections';

const OurProjectsPage = () => {
  return (
    <>
      <OurProjectsBanner />
      <OurProjectsLogo />
      <OurProjectsClients />
      <OurProjectsContact />
    </>
  );
};

export default OurProjectsPage;
